import React, { useContext, useState } from "react";
import Layout from "../Layout";
import { UserContext } from "../providers/userData";
import { AppDataContext } from "../providers/appData";
import CurrencyFormat from "../helper/CurrencyFormat";

function Developer() {
  const { user } = useContext(UserContext);
  const { appData } = useContext(AppDataContext);

  const dataNetworks = ["MTN", "GLO", "AIRTEL", "ETISALAT"];
  const cableNetworks = ["DSTV", "GOTV", "STARTIMES"];
  const discoList = [
    "IKEDC",
    "EKEDC",
    "KEDCO",
    "PHED",
    "JED",
    "IBEDC",
    "KAEDCO",
    "AEDC",
    "EEDC",
    "BEDC",
    "ABA",
    "YEDC",
  ];

  const [visibleTables, setVisibleTables] = useState({});
  const [visibleCableTables, setVisibleCableTables] = useState({});
  const [visibleDiscoTables, setVisibleDiscoTables] = useState({});
  const [showAirtime, setShowAirtime] = useState(false);

  const toggleTable = (key) => {
    setVisibleTables((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleCableTable = (network) => {
    setVisibleCableTables((prev) => ({
      ...prev,
      [network]: !prev[network],
    }));
  };

  const toggleDiscoTable = (disco) => {
    setVisibleDiscoTables((prev) => ({
      ...prev,
      [disco]: !prev[disco],
    }));
  };

  const renderStandardTable = (plans, priceUnit = "₦", value = false) => (
    <div className="overflow-x-auto mb-6">
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr className="bg-gray-100 dark:bg-gray-700">
            <th className="border px-4 py-2 text-left">Plan Name</th>
            <th className="border px-4 py-2 text-center">Plan ID</th>
            {value && (
              <th className="border px-4 py-2 text-center">Value (₦)</th>
            )}
            <th className="border px-4 py-2 text-center">
              Price ({priceUnit})
            </th>
          </tr>
        </thead>
        <tbody>
          {plans.map((plan) => (
            <tr
              key={plan.id}
              className="hover:bg-gray-50 dark:hover:bg-gray-600"
            >
              <td className="border px-4 py-2">{plan.name}</td>
              <td className="border px-4 py-2 text-center">{plan.id}</td>
              {value && (
                <td className="border px-4 py-2 text-center">
                  {CurrencyFormat(plan.value)}
                </td>
              )}
              <td className="border px-4 py-2 text-center">
                {CurrencyFormat(plan.api_price)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderAirtimeTable = (plans) => {
    const networkList = ["MTN", "GLO", "AIRTEL", "ETISALAT"];
    return (
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-100 dark:bg-gray-700">
              <th className="border px-4 py-2 text-left">Network</th>
              <th className="border px-4 py-2 text-left">Price (%)</th>
            </tr>
          </thead>
          <tbody>
            {networkList.map((network) => {
              const plan = plans[network];
              return (
                <tr
                  key={network}
                  className="hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="border px-4 py-2">
                    {plan?.network || network}
                  </td>
                  <td className="border px-4 py-2">
                    {plan ? CurrencyFormat(plan.api_price) + "%" : "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  document.title = "Self Fix Funding" + appData.business.name;

  return (
    <Layout PageName={"Developer's API"}>
      <div className="px-0 py-8">
        <div className="font-medium text-sm">
          <h1 className="mb-3 text-dark mt-4 text-center">
            💡 Power up your app with our lightweight API and gain access to
            faster transactions and exclusive product discounts.
          </h1>

          <div className="mt-5">
            <h3 className="font-medium mb-3 md:mt-6 dark:text-white">
              User Type: {user?.data?.type} User
            </h3>
            <p className="my-2">Base URL: {appData.business.website}/api</p>
            <p className="my-2">
              API Documentation:{" "}
              <label
                onClick={() => {
                  localStorage.getItem("isMobileApp")
                    ? window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                          command: "openExternalUrl",
                          data: "https://documenter.getpostman.com/view/11737658/TzefBPWx",
                        })
                      )
                    : window.open(
                        "https://documenter.getpostman.com/view/11737658/TzefBPWx",
                        "_blank"
                      );
                }}
                className="text-blue-500 underline"
              >
                View Postman Docs
              </label>
            </p>
            {user?.data?.type === "NORMAL" ? (
              <>
                {" "}
                <p className="my-5">
                  Boss🧑‍💼, you are currently a Normal User. Do you have a website
                  or app? You can integrate our API for direct access. Simply
                  reach out to customer care to convert your account to an
                  API-enabled account and grant you access to our discounted API
                  price list and documentation.
                </p>
                <p className="text-center mt-20">
                  <b>
                    <i>API Price list is not visible to Normal User</i>
                  </b>
                </p>
              </>
            ) : (
              <>
                {/* === DATA PLANS === */}
                <h2 className="mt-6 underline">DATA PLANS</h2>
                {dataNetworks.map((network) => {
                  const plans = appData.data_plans?.[network] || [];
                  return (
                    <div key={network} className="mt-4">
                      <p className="font-semibold">
                        {network} Plans
                        <button
                          onClick={() => toggleTable(network)}
                          className="text-yellow-400 hover:bg-yellow-500 font-bold py-1 px-3 ml-3 rounded"
                        >
                          {visibleTables[network] ? "Hide" : "Show"}
                        </button>
                      </p>
                      {visibleTables[network] && renderStandardTable(plans)}
                    </div>
                  );
                })}

                {/* === AIRTIME PLANS === */}
                <h2 className="mt-6 underline">AIRTIME PLANS</h2>
                <div className="mt-2">
                  <p className="font-semibold">
                    Airtime
                    <button
                      onClick={() => setShowAirtime((prev) => !prev)}
                      className="text-yellow-400 hover:bg-yellow-500 font-bold py-1 px-3 ml-3 rounded"
                    >
                      {showAirtime ? "Hide" : "Show"}
                    </button>
                  </p>
                  {showAirtime &&
                    renderAirtimeTable(appData.airtime_plans || [])}
                </div>

                {/* === CABLE PLANS === */}
                <h2 className="mt-6 underline">CABLE PLANS</h2>
                {cableNetworks.map((network) => {
                  const plans = appData.cable_plans?.[network] || [];
                  return (
                    <div key={network} className="mt-4">
                      <p className="font-semibold">
                        {network} Plans
                        <button
                          onClick={() => toggleCableTable(network)}
                          className="text-yellow-400 hover:bg-yellow-500 font-bold py-1 px-3 ml-3 rounded"
                        >
                          {visibleCableTables[network] ? "Hide" : "Show"}
                        </button>
                      </p>
                      {visibleCableTables[network] &&
                        renderStandardTable(plans, "%", true)}
                    </div>
                  );
                })}

                {/* === ELECTRICITY PLANS === */}
                <h2 className="mt-6 underline">ELECTRICITY PLANS</h2>
                {discoList.map((disco) => {
                  const plans = appData.electric_plans?.[disco] || [];
                  return (
                    <div key={disco} className="mt-4">
                      <p className="font-semibold">
                        {disco} Plans
                        <button
                          onClick={() => toggleDiscoTable(disco)}
                          className="text-yellow-400 hover:bg-yellow-500 font-bold py-1 px-3 ml-3 rounded"
                        >
                          {visibleDiscoTables[disco] ? "Hide" : "Show"}
                        </button>
                      </p>
                      {visibleDiscoTables[disco] &&
                        renderStandardTable(plans, "%")}
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Developer;
